import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouseChimney } from '@fortawesome/sharp-solid-svg-icons/faHouseChimney';
import React from 'react';
import classnames from 'classnames';
import { AddressPropType } from '../../prop-types/address';
import PropTypes from 'prop-types';

import style from './address.module.less';

const AddressVerification = () => (
  <div className={style['address-verification']}>
    <FontAwesomeIcon icon={faHouseChimney} />
    Address Verified
  </div>
);

const Address = ({ address, addressWrapperClassName = '', shouldRenderVerification = false }) => {
  const {
    name = '',
    company = '',
    phone = '',
    line1 = '',
    line2 = '',
    line3 = '',
    city = '',
    state = '',
    postalCode = '',
    countryCode = '',
    email = '',
  } = address;

  const stateSection = state ? `, ${state}` : '';
  return (
    <div className={classnames(style.data, addressWrapperClassName)} data-testid='read-only-address'>
      <div>{name}</div>
      {company && <div>{company}</div>}
      <div>{line1}</div>
      <div>{line2}</div>
      {line3 && <div>{line3}</div>}
      <div>{`${city}${stateSection} ${postalCode} ${countryCode}`}</div>
      <div>{phone}</div>
      <div>{email}</div>
      {shouldRenderVerification && <AddressVerification />}
    </div>
  );
};

Address.propTypes = {
  address: AddressPropType.isRequired,
  shouldRenderVerification: PropTypes.bool,
  addressWrapperClassName: PropTypes.string,
};

export default Address;
